import { EDD_SOURCE, EDD_V2_SOURCE } from '@pperform/pp-constants/parcel';
import APIError from 'exceptions/APIError';
import { fetchSingleEddBySource } from 'components/EstimatedDeliveryDate/fetchers/edd.fetchers';
import type { EddSource } from 'interfaces/edd.interface';

type EddSourceType = typeof EDD_V2_SOURCE[keyof typeof EDD_V2_SOURCE];

export const getShipmentEddBySource = async (
  orgId: number,
  shipmentPk: number,
  eddSource: EddSourceType,
): Promise<EddSource | null> => {
  try {
    const {
      data: { eddValue },
    } = await fetchSingleEddBySource(orgId, shipmentPk, eddSource);

    if (!eddValue?.start) return null;

    return {
      first: { time: eddValue.start },
      last: eddValue.end ? { time: eddValue.end } : null,
      source: EDD_SOURCE.predict,
      type: eddValue.type,
    };
  } catch (error) {
    // 404: Predict EDD doesn't exist (cacheable state)
    if (error instanceof APIError && error.response?.status === 404) {
      return null;
    }

    // Other errors: network, 500, etc - allow React Query to refetch
    throw error;
  }
};
